import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#6d0fa7",
	height: 10,
	viewBox: "0 0 14 10",
	width: 14,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m10.4737 5.83333-2.98334 2.99167 1.175 1.175 5.00004-5-5.00004-5-1.175 1.175 2.98334 2.99167h-10.141669v1.66666z" })
});
export { SvgRightArrow as ReactComponent };
